import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "../../api/axios";
import dayjs from "dayjs";
import { PreferencesContext } from "../../context/PreferencesContext";
import { AuthContext } from "../../context/AuthContext";

import AdminSalesDashboard from "../../components/reports/SalesDashboard";

export default function AdminSalesDashboardPage() {
  const { organization, academicYear } = useContext(PreferencesContext);

  const { user } = useContext(AuthContext);

  const [branches, setBranches] = useState([]);
  const [masters, setMasters] = useState({ grades: [] });
  const [filters, setFilters] = useState({
    branchIds: [],
    grade: "",
    saleType: "books",
    startDate: dayjs().set("month", 1).set("date", 1).format("YYYY-MM-DD"), // 01 May
    endDate: dayjs().endOf("day").format("YYYY-MM-DD"),
  });

  const [loading, setLoading] = useState(true);

  // Fetch branches (respecting branch manager)
  useEffect(() => {
    if (!organization) return;

    axios.get(`/branches?orgId=${organization}`, {}).then((res) => {
      let branchList = res.data || [];

      if (user?.role === "branch_manager") {
        branchList = branchList.filter((b) => user.branches.includes(b._id));
      }

      setBranches(branchList);

      // Auto-set branch filter if only one
      if (branchList.length === 1) {
        setFilters((prev) => ({ ...prev, branchIds: [branchList[0]._id] }));
      }
    });
  }, [organization]);

  // Fetch grades
  useEffect(() => {
    if (!organization) return;
    axios
      .get(`/masters/${organization}`, {})
      .then((res) => setMasters({ grades: res.data.grades || [] }));
  }, [organization]);

  // Mark ready when org and filters exist
  useEffect(() => {
    if (organization && academicYear) {
      setFilters((prev) => ({ ...prev, academicYear }));
      setLoading(false);
    }
  }, [organization, academicYear]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const allFilters = useMemo(
    () => ({ orgId: organization, academicYear: academicYear, ...filters }),
    [organization, academicYear, filters]
  );

  if (loading) return <CircularProgress />;

  return (
    <Box p={2}>
      <Typography variant="h5" gutterBottom>
        Sales Dashboard
      </Typography>

      <Box display="flex" gap={2} flexWrap="wrap" mb={3}>
        {/* {branches.length > 1 && (
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Branch</InputLabel>
            <Select
              label="Branch"
              multiple
              value={filters.branchIds}
              onChange={(e) => handleFilterChange("branchIds", e.target.value)}
            >
              {branches.map((b) => (
                <MenuItem key={b._id} value={b._id}>
                  {b.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl sx={{ minWidth: 160 }}>
          <InputLabel>Grade</InputLabel>
          <Select
            label="Grade"
            value={filters.grade}
            onChange={(e) => handleFilterChange("grade", e.target.value)}
          >
            <MenuItem value="">All Grades</MenuItem>
            {masters.grades.map((g) => (
              <MenuItem key={g} value={g}>
                {g}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        {/* Date Range */}
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel>Sale type</InputLabel>
          <Select
            label="Sale type"
            value={filters.saleType}
            onChange={(e) => handleFilterChange("saleType", e.target.value)}
          >
            <MenuItem value="books">Books only</MenuItem>
            <MenuItem value="uniforms">Uniforms only</MenuItem>
            <MenuItem value="all">All sales</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Start Date"
          type="date"
          value={filters.startDate}
          onChange={(e) => handleFilterChange("startDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={filters.endDate}
          onChange={(e) => handleFilterChange("endDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Box>

      {/* 📊 Dashboard View */}
      <AdminSalesDashboard filters={allFilters} />
    </Box>
  );
}
